<div vng-dialog-title>{{ id ? "Update " + tooltip(data.data) : "Add Category" }}</div>
<vng-dialog-content>
<form class="clearfix form" [formGroup]="form" (ngSubmit)="submitForm()">
  <div class="category-fields top-gap">
    <vng-input
      [label]="tooltip(data.data) + ' Name'"
      [placeholder]="tooltip(data.data) + ' Name'"
      class="w-100"
      type="text"
      [formControl]="form.controls['name']"
      [flyMsgIgnore]="true"
      [error]="
        form.controls['name'].dirty || form.controls['name'].touched
          ? form.controls['name'].hasError('required')
            ? 'Category Name is required'
            : form.controls['name'].hasError('maxlength') ? 'Maximum 26 Characters' : ''
          : ''
      "
    ></vng-input>
    <p *ngIf="categoryErrMsg" class="warn-txt">
      <img class="warn-txt__icon" src="../../../assets/images/warning.png" alt="" />
      <span> {{ categoryErrMsg[0] }}</span>
      <span class="warn-txt__detail"> {{ categoryErrMsg[1] }}</span>
    </p>
    <p *ngIf="subCategoryErrMsg" class="warn-txt">
      <img class="warn-txt__icon" src="../../../assets/images/warning.png" alt="" />
      <span> {{ subCategoryErrMsg[0] }}</span>
      <span class="warn-txt__detail"> {{ subCategoryErrMsg[1] }}</span>
    </p>
    <!-- L2: was `checked="{{ isSelectDisable.value }}"` + a (click) hack.
         Attribute interpolation always yields a non-empty (truthy) string, so
         the box rendered pre-checked regardless of the control. It is now a
         plain CVA binding; (change) fires AFTER the control has the new value
         (VngCheckbox.toggle() calls onChange before emitting). -->
    <vng-checkbox [formControl]="isSelectDisable" (change)="onNestChange()"
      >Nest {{ tooltip(data.data).toLowerCase() }} under:</vng-checkbox
    >
    <!-- R5: mat-select + the old select-search plugin -> vng-select [searchable]="true".
         L2: no [disabled] here — it collides with [formControl] (the CVA's
         setDisabledState overwrites the input at init). The enabled/disabled
         state is driven from the TS via category_id.enable()/.disable(). -->
    <vng-select
      label="Please select a parent..."
      placeholder="Please select a parent..."
      [formControl]="form.controls['category_id']"
      [options]="parentCategoryOptions"
      [searchable]="true"
      [required]="isSelectDisable.value"
      [error]="
        (form.controls['category_id'].dirty || form.controls['category_id'].touched) &&
        form.controls['category_id'].hasError('required') &&
        isSelectDisable.value
          ? 'Please select the category path'
          : ''
      "
    >
    </vng-select>
  </div>
  <div style="display: flex; justify-content: center; align-items: center; gap: 15px" class="top-gap">
    <button class="btn-cta btn-secondary category-rename-action" type="button" vng-button variant="outline" tabindex="2" (click)="close()">
      Cancel
    </button>
    <button
      class="btn-cta btn-primary category-rename-action"
      type="submit"
      vng-button
      variant="primary"
      tabindex="-1"
    >
      {{ id ? "Update" : "Save" }}
    </button>
  </div>
</form>
</vng-dialog-content>
